/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const ErrorMessage = styled.p`
  color: red;
  margin: 10px;
`;
